import { useState } from "react";

const greetings = [
  "Herzlich Willkommen! Wem sagen wir heute Danke? 💘",
  "Die richtigen Worte kommen immer von Herzen. 💝",
  "Bist du bereit für Herzlichkeit? ❤️",
  "Hallo! Ich helfe dir, die richtigen Worte zu finden. 💕",
];

const useGetGreeting = () => {
  const [randomIndex] = useState<number>(
    Math.floor(Math.random() * greetings.length),
  );

  return greetings[randomIndex];
};

export { useGetGreeting };
